<template>
<div>
    <div :class="['effectInput',active?'activeDiv':'',filterable?'filterableSelect':'']"  v-if="!isLabel">
        <span class="effectSpan">{{label}}</span>
        <Select  v-model="effectValue"  @on-open-change="blurEvent($event)" @on-change="inputClick" :filterable="filterable"  :disabled='disabled'>
            <Option v-for="(item,index) in options" :value="item.value" :key="index">{{isLanguage?$t(item.label):item.label}}</Option>
        </Select>
    </div>
    <Select v-model="effectValue" v-if="isLabel" :filterable="filterable" :placeholder="label" :disabled='disabled' @on-change="change">
        <Option v-for="(item,index) in options" :value="item.value" :key="index">{{$t(item.label)}}</Option>
    </Select>
</div>
    
</template>
<script>
    export default {
        props: ['label','value','options','isLanguage','isLabel','filterable','disabled'],
        data () {
            return {
                effectValue: '',
                active:false
            }
        },
        created(){
            
        },
        watch: {
            value(val){
				this.effectValue = val
                if(val){
                    this.active = true
                }else{
                    this.active = false
                }
            },
            effectValue (val) {
                this.$emit('input',val)
            }
        },
        methods: {
            inputClick (val) {
                this.active = true
                this.$emit('selectChange',val)
            },
            blurEvent (val) {
                // console.log(val)
                if(!this.value && !this.filterable){
                    this.active = false
                }else{
                    this.active = true
                }
            },
            change(val){
                this.$emit('selectChange',val)
            }
        },
        created() {
            this.effectValue = this.value
            if(this.effectValue){
                this.active = true
            }
            // console.log(this.isLanguage)
        }
    }
</script>
